import * as Yup from "yup";

const PanchangSchema = Yup.object().shape({
  start_time: Yup.string().required("Start Date is required"),
  end_time: Yup.string().required("End Date is required"),
  day: Yup.string().required("Tithi is required"),
  samvat: Yup.string().required("Samvat is required"),
});

export default PanchangSchema;